import React, { FunctionComponent } from 'react';
import { Box, Text } from 'rebass/styled-components';
import {
  ConfigActionSendMessage, ConfigActionTransferToAgent,
  ConfigActionTransferToSkill, ConfigActionExecuteFaaS, PolicyExecutionStatus,
} from '@liveperson/lpcontextschemalib';
import {
  PolicyActionProps,
} from '..';
import { singlePolicyActionParser } from '../util/parsers';

interface SinglePolicyActionProps {
  action: PolicyExecutionStatus | ConfigActionSendMessage | ConfigActionTransferToAgent |
  ConfigActionTransferToSkill | ConfigActionExecuteFaaS;
  isEmphasizedPolicyResult: boolean;
}

const SinglePolicyAction: FunctionComponent<
SinglePolicyActionProps> = ({ action, isEmphasizedPolicyResult }: SinglePolicyActionProps) => {
  const { title, message } = singlePolicyActionParser(action);
  return (
    <Text
      variant={isEmphasizedPolicyResult ? 'primaryBold' : 'primary'}
      sx={{
        display: '-webkit-box',
        '-webkit-line-clamp': '2',
        '-webkit-box-orient': 'vertical',
        overflow: 'hidden',
      }}
    >
      <span>{title}</span>
      <br />
      <span>{message}</span>
    </Text>
  );
};

const PolicyAction: FunctionComponent<
PolicyActionProps> = ({
  actions,
  isEmphasizedPolicyResult,
}: PolicyActionProps) => {
  if (Array.isArray(actions)) {
    return (
      <>
        {actions?.map((action, idx) => (
          <Box mb={idx === actions.length - 1 ? 0 : 2} key={idx}>
            <SinglePolicyAction
              action={action}
              isEmphasizedPolicyResult={isEmphasizedPolicyResult}
            />
          </Box>
        ))}
      </>
    );
  }
  return (
    <SinglePolicyAction
      action={actions as PolicyExecutionStatus}
      isEmphasizedPolicyResult={isEmphasizedPolicyResult}
    />
  );
};

export default PolicyAction;
